const resource = {
  ADMIN_LOGIN: 'login',
  ADMIN_MEMBERS: 'members',
  ADMIN_ARTIFACT: 'artifact',
  ADMIN_LIST_CHAPTER: 'chapters',
};

export default resource;
